import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllCertificadoDigitalCadastro } from '../service';
import {
  LIST_CERTIFICADO_DIGITAL_CADASTRO,
  LIST_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
  LIST_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
  LIST_CERTIFICADO_DIGITAL_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllCertificadoDigitalCadastro(action) {
  yield put({ type: LIST_CERTIFICADO_DIGITAL_CADASTRO_PENDING })

  try {
    const list = yield call(findAllCertificadoDigitalCadastro)
    
    yield put({ type: LIST_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_CERTIFICADO_DIGITAL_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllCertificadoDigitalCadastro() {
  yield takeLatest(LIST_CERTIFICADO_DIGITAL_CADASTRO, sagaListAllCertificadoDigitalCadastro)
}